import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';

import toast from 'components/partials/toast/toast';

import { createConversation } from 'api/ai-assistant/ai-assistant-api';

import { AI_ASSISTANT_CONVERSATIONS_KEY } from '../ai-assistant.constants';

interface UseApiCreateConversationArgs {
  oktaUserId: string;
  clientId: string | number;
}

interface ApiErrorLike {
  data?: { detail?: string };
}

export const useApiCreateConversation = ({
  oktaUserId,
  clientId,
}: UseApiCreateConversationArgs): UseMutationResult<
  unknown,
  ApiErrorLike,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation<unknown, ApiErrorLike, unknown>({
    mutationFn: (data) => createConversation({ oktaUserId, data, clientId }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [AI_ASSISTANT_CONVERSATIONS_KEY, oktaUserId, clientId],
      }),
    onError: (error) =>
      toast.error({
        title: 'Error creating conversation',
        message: error?.data?.detail,
      }),
  });
};
